module.exports = __webpack_public_path__ + "static/media/dealer.f2b65228.svg";